import momoicon from '../../../assets/img/hero/footer/mtnmomo.jpg'
import vodacash from '../../../assets/img/hero/footer/vodacash.jpg'
import { MastercardIcon, VisacardIcon } from '../../atoms/icons'

export default function Footer() {
    return (
        <div className='w-full bg-primary flex justify-center items-center'>

            <div className='p-5 w-11/12 flex justify-between items-center'>
                <h5 className='text-secondary2'>&#169; 2022 The Shopkeeper <span className="inline-block w-1 h-1 bg-secondary rounded-full"/></h5>
            </div>

            <div className="flex">
                <div className="h-3 w-7 mr-2">
                    <MastercardIcon />
                </div>
                <div className="h-3 w-7 mr-2">
                    <VisacardIcon />
                </div>
                <div className="h-7 w-7 mr-2 rounded-full overflow-hidden">
                    <img src={momoicon} alt="momo icon" className="w-full h-full" />
                </div>
                <div className="h-7 w-7 mr-2 rounded-full overflow-hidden">
                    <img src={vodacash} alt="vodafone cash icon" className="w-full h-full" />
                </div>
            </div>
            
        </div>
    )
}
